import axios from 'axios';

export default class RangerService {
  static async sendTestChatMessage(sessionId, message, apiEndpoint, phone = null) {
    const rangerUrl = process.env.VUE_APP_RANGER_URL;
    if (!rangerUrl) {
      // eslint-disable-next-line no-console
      console.error('VUE_APP_RANGER_URL no está configurada — agrégala a .env.local y reinicia npm run serve.');
      return { status: 'error' };
    }
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const body = { session_id: sessionId, message };
      if (phone) body.phone = phone;
      const response = await axios.post(
        `${rangerUrl}${apiEndpoint}`,
        body,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      const {
        reply,
        phase,
        reason_category: reasonCategory,
        collected_variables: collectedVariables,
        outcome,
        rules_version: rulesVersion
      } = response.data;
      return {
        status: 'ok',
        data: {
          reply,
          phase: phase ?? null,
          reasonCategory: reasonCategory ?? null,
          collectedVariables: collectedVariables ?? {},
          outcome: outcome ?? null,
          rulesVersion: rulesVersion ?? null
        }
      };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
